import React, { useState } from 'react';
import {
  Box,
  CssBaseline,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import Header from './Header';
import Navigation from './Navigation';
import Dashboard from '../Dashboard/Dashboard';
import DeckManager from '../Deck/DeckManager';
import FormatManager from '../Format/FormatManager';
import MatchRecorder from '../Match/MatchRecorder';
import StatisticsDashboard from '../Statistics/StatisticsDashboard';

const MainLayout: React.FC = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'decks':
        return <DeckManager />;
      case 'formats':
        return <FormatManager />;
      case 'record':
        return <MatchRecorder />;
      case 'statistics':
        return <StatisticsDashboard />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      
      <Box
        component="header"
        sx={{
          position: 'fixed',
          top: 0,
          left: { xs: 0, md: '240px' },
          right: 0,
          zIndex: theme.zIndex.appBar,
        }}
      >
        <Header />
      </Box>

      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleMobileToggle}
          sx={{
            position: 'fixed',
            top: 8,
            left: 8,
            zIndex: theme.zIndex.appBar + 1,
            backgroundColor: 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Navigation
        activeTab={activeTab}
        onTabChange={setActiveTab}
        mobileOpen={mobileOpen}
        onMobileToggle={handleMobileToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - 240px)` },
          mt: { xs: '96px', sm: '104px' },
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default MainLayout;